module.exports = __webpack_public_path__ + "static/media/venus-double.f1a45dbe.svg";